var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_469",
    "data-name": "Groupe 469",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.257,
    height: 21.184,
    viewBox: "0 0 19.257 21.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56c3f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#4b8eed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4778ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4778ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4832c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#56c3f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384,
    stopColor: "#52bcef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#48aaed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47a7ed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_55",
    "data-name": "Trac\\xE9 55",
    d: "M566.693,89.566,563,86.906a.593.593,0,0,1-.246-.481V80.919a1.493,1.493,0,0,1,2.273-1.273l7.943,4.864a.593.593,0,0,1,.038.986l-5.623,4.069A.593.593,0,0,1,566.693,89.566Z",
    transform: "translate(-562.719 -79.424)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M567.386,188.537l5.979,4.311a.593.593,0,0,1-.078,1.01l-8.363,4.242a1.493,1.493,0,0,1-2.168-1.331v-5.1a.592.592,0,0,1,.247-.481l3.69-2.65A.593.593,0,0,1,567.386,188.537Z",
    transform: "translate(-562.719 -177.079)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M633.749,146.212l-5.662,2.892h0a.553.553,0,0,1-.576-.045l-5.879-4.261a.561.561,0,0,1,0-.908l5.406-3.933a.553.553,0,0,1,.616-.024l.062.038,6.132,3.781A1.414,1.414,0,0,1,633.749,146.212Z",
    transform: "translate(-615.258 -133.562)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M562.395,165.7v2.773a.334.334,0,0,0,.513.283l1.952-1.233a.334.334,0,0,0,.029-.545l-1.952-1.541A.334.334,0,0,0,562.395,165.7Z",
    transform: "translate(-562.395 -156.422)",
    fill: "url(#linear-gradient-4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.27284a90.svg";
export { ForwardRef as ReactComponent };